import request from './base'
export const regionList = (params) => {
    return request.post("/admin/v1/region/list", params)
}


// WEBPACK FOOTER //
// ./src/api/region.js